/*!
 * Copyright © 2018-2019. Verizon Connect Ireland Limited. All rights reserved.
 */

import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { filter, take } from 'rxjs/operators';

import { EMapTypeId } from '../../../core/models';
import { GoogleMapsLoaderService } from '../../../maps/services';

@Component({
  selector: 'fm-map-type-switcher-control',
  templateUrl: './map-type-switcher-control.component.html',
  styleUrls: ['./map-type-switcher-control.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MapTypeSwitcherControlComponent implements OnInit {
  @Input()
  public mapType: EMapTypeId;
  @Output()
  public switchMapType: EventEmitter<EMapTypeId> = new EventEmitter();

  public googleMapsLoaded = false;
  public EMapType = EMapTypeId;

  constructor(private readonly _googleMapsLoaderService: GoogleMapsLoaderService, private readonly _changeDetector: ChangeDetectorRef) {}

  ngOnInit(): void {
    this._googleMapsLoaderService.googleMapsLoaded$
      .pipe(
        filter((loaded: boolean) => loaded),
        take(1)
      )
      .subscribe(() => this._onGoogleMapsLoaded());
  }

  public switchMapTypeClick(mapType: EMapTypeId): void {
    this.switchMapType.emit(mapType);
  }

  private _onGoogleMapsLoaded(): void {
    this.googleMapsLoaded = true;
    this._changeDetector.detectChanges();
  }
}
